"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.maxby"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

var _lodash3 = _interopRequireDefault(require("lodash.startcase"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRouterDom = require("react-router-dom");

var _getVideoOutputName = _interopRequireDefault(require("@devsta/get-video-output-name"));

var _uiKit = require("@devsta/ui-kit");

var _UploadVideo = _interopRequireDefault(require("./UploadVideo"));

var _OutputBlockStatusHeader = _interopRequireDefault(require("./OutputBlockStatusHeader"));

var _OutputBlockDueDate = _interopRequireDefault(require("./OutputBlockDueDate"));

var _getTimeRemaining2 = _interopRequireDefault(require("../../../../../common/utils/getTimeRemaining"));

var _colors = require("../../../../../common/styles/colors");

var _getRejectionReasons = _interopRequireDefault(require("../utils/getRejectionReasons"));

require("../styles/output-block.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Addon = function Addon(_ref) {
  var addon = _ref.addon,
      label = _ref.label;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "output-block__details__container__row"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    className: "output-block__details__container__row__text"
  }, (0, _lodash3.default)(addon)), /*#__PURE__*/_react.default.createElement("div", {
    className: "output-block__details__container__row__card"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    className: "output-block__details__container__row__card__text"
  }, (0, _lodash3.default)(label))));
};

function getOutputLink(output) {
  if (output.status.name === 'DRAFT' || output.status.name === 'PENDING_MASTER') {
    return "/video-tool/builder/".concat(output.videoId);
  }

  if (output.status.name === 'APPROVED') {
    return "/video-tool/complete/".concat(output.videoId, "/").concat(output.outputId);
  }

  return "/review/".concat(output.videoId, "/").concat(output.outputId);
}

var OutputBlock = /*#__PURE__*/function (_Component) {
  _inherits(OutputBlock, _Component);

  var _super = _createSuper(OutputBlock);

  function OutputBlock(props) {
    var _this;

    _classCallCheck(this, OutputBlock);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getCurrentVersion", function () {
      var versions = _this.props.output.versions;
      return (0, _lodash.default)(versions, 'versionNumber');
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmitInternal", function () {
      var _this$props = _this.props,
          outputId = _this$props.output.outputId,
          submitInternal = _this$props.submitInternal;

      if (!submitInternal) {
        return null;
      }

      return submitInternal(outputId);
    });

    _defineProperty(_assertThisInitialized(_this), "onUploadAsset", function (uploadedAssetId) {
      if (!uploadedAssetId) {
        return;
      }

      _this.setState({
        uploadedAssetId: uploadedAssetId
      });
    });

    _this.state = {};
    return _this;
  }

  _createClass(OutputBlock, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$video = _this$props2.video,
          name = _this$props2$video.name,
          organisationId = _this$props2$video.organisationId,
          masterOutput = _this$props2$video.masterOutput,
          output = _this$props2.output,
          _this$props2$output = _this$props2.output,
          latestVersion = _this$props2$output.latestVersion,
          status = _this$props2$output.status,
          versions = _this$props2$output.versions,
          isMaster = _this$props2$output.isMaster,
          onHoldDate = _this$props2$output.onHoldDate,
          onHoldReason = _this$props2$output.onHoldReason,
          readableId = _this$props2$output.readableId,
          onViewInternalNotes = _this$props2.onViewInternalNotes,
          getCaptions = _this$props2.getCaptions,
          dropZoneDisplayed = _this$props2.dropZoneDisplayed,
          getFormattedAddon = _this$props2.getFormattedAddon;
      var uploadedAssetId = this.state.uploadedAssetId;

      var _this$getCurrentVersi = this.getCurrentVersion(),
          appliedAddons = _this$getCurrentVersi.appliedAddons,
          dueDate = _this$getCurrentVersi.dueDate,
          assetId = _this$getCurrentVersi.assetId;

      var RUSH_EDIT = appliedAddons.RUSH_EDIT;

      var _getTimeRemaining = (0, _getTimeRemaining2.default)({
        dueDate: dueDate,
        RUSH_EDIT: RUSH_EDIT,
        onHoldDate: onHoldDate
      }),
          hoursLeft = _getTimeRemaining.hoursLeft,
          percentageComplete = _getTimeRemaining.percentageComplete;

      var captions = getCaptions(appliedAddons);
      var isEditing = status.name === 'EDITING';
      var outputTitle = (0, _getVideoOutputName.default)(output, name);
      var color = _colors.STATUS_COLORS_MAP[status.name];
      var rejectionReasons = (0, _getRejectionReasons.default)({
        output: output
      });
      var masterOutputApproved = (0, _lodash2.default)(masterOutput, 'status.name') === 'APPROVED';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "output-block"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('output-block__tags', {
          'output-block__tags--disabled': !isEditing
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "output-block__tags__version",
        style: {
          background: color
        }
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        className: "output-block__tags__tag-text"
      }, "Version 0", latestVersion)), latestVersion === 1 && /*#__PURE__*/_react.default.createElement("div", {
        className: "output-block__tags__fc"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        className: "output-block__tags__tag-text"
      }, "FC"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "output-block__overview"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "output-block__title-container"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading4: true,
        className: "output-block__title"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: getOutputLink(output)
      }, "[".concat(readableId, "] ").concat(outputTitle))), isMaster ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        name: "master",
        color: "goldenTainoi"
      }) : null, onHoldDate ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        className: "output-block__on-hold",
        name: "alert",
        size: 20,
        color: "thunderBird",
        tooltipId: "toolId-".concat(output.outputId),
        tooltipLabel: "Video on hold: ".concat(onHoldReason)
      }) : null), /*#__PURE__*/_react.default.createElement(_OutputBlockDueDate.default, {
        dueDate: dueDate,
        status: status.name
      })), /*#__PURE__*/_react.default.createElement(_OutputBlockStatusHeader.default, {
        status: status.name,
        dueDate: dueDate,
        hoursLeft: hoursLeft,
        percentageComplete: percentageComplete
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "output-block__upload"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "output-block__wrapper"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        className: "output-block__subtitle"
      }, "Upload Video"), rejectionReasons && rejectionReasons.length > 0 && /*#__PURE__*/_react.default.createElement("a", {
        role: "button",
        tabIndex: "0",
        className: "output-block__notes",
        onKeyDown: onViewInternalNotes(rejectionReasons),
        onClick: onViewInternalNotes(rejectionReasons)
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "output-block__notes__view"
      }, "View Notes"), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        name: "contract"
      }))), /*#__PURE__*/_react.default.createElement(_UploadVideo.default, {
        versions: versions,
        latestVersion: latestVersion,
        organisationId: organisationId,
        appliedAddons: appliedAddons,
        dropZoneDisplayed: dropZoneDisplayed,
        isPendingMaster: !isMaster && !masterOutputApproved,
        onUploadAsset: this.onUploadAsset
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "output-block__details"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        className: "output-block__subtitle"
      }, "Output Details"), /*#__PURE__*/_react.default.createElement("div", {
        className: "output-block__details__container"
      }, Object.keys(appliedAddons).map(function (key) {
        var addonData = getFormattedAddon(key, appliedAddons);
        if (!addonData) return null;
        return /*#__PURE__*/_react.default.createElement(Addon, {
          addon: key,
          key: key,
          label: addonData.label
        });
      }), captions.map(function (_ref2) {
        var captionValue = _ref2.captionValue,
            language = _ref2.language,
            type = _ref2.type;
        return /*#__PURE__*/_react.default.createElement(Addon, {
          key: "".concat(type, "-").concat(language),
          addon: type,
          label: captionValue.label
        });
      })), (assetId || uploadedAssetId) && !['INTERNAL_REVIEW', 'PENDING_MASTER', 'APPROVED'].includes(status.name) ? /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        className: "output-block__details__submitinternal",
        onClick: this.onSubmitInternal
      }, "Submit internal") : null));
    }
  }]);

  return OutputBlock;
}(_react.Component);

var _default = OutputBlock;
exports.default = _default;